import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse,HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { MenuItem } from 'primeng/api';
import { RecentTasks, TaskCountItem } from './tasks';
import { GlobalNamespace as _GlobalNS, environment } from '../../environments/environment';
import { GlobalService } from './../core/global.service';
import { catchError } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class TaskService {
  taskStatus = { OverDue: 1, Warning: 2, OnTime: 3, Complete: 4, NC: 5, Paused: 6, UA: 7, Processing: 120 };
  constructor(private _http: HttpClient, private _global: GlobalService) { }

  getTasksByPropertyId() {
    const api = (<any>_GlobalNS).api.task.list;
    const propertyid = this._global.find((<any>_GlobalNS).paths.PropertyId);
    const url = (environment.production) ? `${api}&PropertyId=${propertyid}` : `${api}?PropertyId=1`;
    return this._http.get(url, {});
  }

  getCompletedTask(): Observable<RecentTasks> {
    const api = (<any>_GlobalNS).api.task.completedTask;
    return this._http.get<RecentTasks>(api);
  }

  getCompletedTaskMenuItems(propertyId) {
    const items: MenuItem[] = [{ id: '1' }, { id: '2' }];
    items.map((i) => {
      i.label = (i.id === '1') ? 'Open in New Window' : 'Open Property';
      i.url = this.getPropertyViewUri(propertyId);
      i.target = (i.id === '1') ? '_blank' : '_self';
    });
    return items;
  }

  getPropertyViewUri(propertyId: number): string {
    const api = (<any>_GlobalNS).routes.property.viewTasks;
    const buildUri = `${api}&property_id=${propertyId}`;
    return buildUri;
  }

  getTaskViewUri(eventlocation: string, property_id: number, eventTrackingID: number, event_tracking_parent?: number): string {
    let buildUri = `${eventlocation}&property_id=${property_id}&eventTrackingID=${eventTrackingID}`;
    buildUri = (event_tracking_parent !== null) ? `${buildUri}&event_tracking_parent=${event_tracking_parent}` : buildUri;
    return (<any>_GlobalNS).api.baseEvent + buildUri;
  }

  getTaskCounter(): Observable<TaskCountItem> {
    const api = (<any>_GlobalNS).api.task.counter;
    const propertyId = this._global.find((<any>_GlobalNS).paths.PropertyId);
    const url = (environment.production) ? `${api}&PropertyId=${propertyId}` : `${api}?PropertyId=1`;

    return this._http.get<TaskCountItem>(url);
  }

  /*
  get current person(logged in) details.
  Tasks which logged in user can completed.
  */
 findByPerson(searchParams?: any, canComplete?: boolean): Observable<RecentTasks[]> {
    const api = (<any>_GlobalNS).api.task.taskToComplete;
    searchParams.CanComplete = canComplete;
    return this._http.get<any>(`${api}`, { params: searchParams }).pipe(
      catchError((err) => {
        return throwError(err);
      })
    );
  }

  /* return task status class name based task status ID */
  getStatusClass(taskStatus: number) {
    if (taskStatus === this.taskStatus.OverDue) {
      return 'overdue';
    } else if (taskStatus === this.taskStatus.Warning) {
      return 'warning';
    } else if (taskStatus === this.taskStatus.OnTime) {
      return 'ontime';
    } else if (taskStatus === this.taskStatus.Paused) {
      return 'paused';
    } else if (taskStatus === this.taskStatus.Processing) {
      return 'processing';
    } else {
      return 'complete';
    }
  }

  getCanCompleteTasksCounter(): Observable<any> {
    const api = (<any>_GlobalNS).api.task.assignedTasks;
    return this._http.get<any>(`${api}`);
  }

}
